export default __webpack_public_path__ + "static/media/RobotoCondensed-Bold.c5fe6dee.ttf";